import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
    selector: 'app-image-input',
    templateUrl: 'image-input.component.html',
    styleUrls: [
        'image-input.component.scss'
    ]
})

export class ImageInputComponent implements OnInit {
    @Input() input: any = null;
    @Input() form: FormGroup = null;
    active: boolean = false;
    filename: string = '';
    imageWrapVisible: boolean = true;
    fileContentVisible: boolean = false;
    imageSrc;
    dragging: boolean = false;
    
    constructor(
        private cdr: ChangeDetectorRef
    ) { }

    ngOnInit() { }    
    
    onFileChange(event) {
        if (this.input.onFileChange == undefined) return;
        this.filename = this.form.controls[this.input.name].value.split('\\').pop();
        try{
            this.input.onFileChange(event);    
        }catch(err){console.log(err);}
        
        if(event.target.files.length==0) return;

        var reader = new FileReader();
        const imageInput = this;
        reader.onloadend = function(e) {
        //   $('.image-upload-wrap').hide();
            imageInput.imageWrapVisible = false;
    
            imageInput.imageSrc = reader.result;
            // console.dir(imageInput.imageSrc);
        //   $('.file-upload-content').show();
            imageInput.fileContentVisible = true;
            imageInput.cdr.detectChanges();

        };
    
        reader.readAsDataURL(event.target.files[0]);
    }

    removeUpload() {
        // $('.file-upload-input').replaceWith($('.file-upload-input').clone());
        // $('.file-upload-content').hide();
        this.fileContentVisible = false;
        // $('.image-upload-wrap').show();
        this.imageWrapVisible = true;
    }
}